import classnames from 'classnames';

import { FlexibleContent } from 'src/Components/Shared/FlexibleContent';

import styles from './KeyValueLine.module.scss';
import { Props } from './KeyValueLine.types';

const KeyValueLine = ({ className, propertyKey, value, keyIcon }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.key}>
        {keyIcon}
        <div className={styles.keyText}>{propertyKey}</div>
      </div>
      <FlexibleContent content={value} className={classnames(styles.value, className)} />
    </div>
  );
};

export default KeyValueLine;
